import type { SessionPort, UserProfilePort } from '../domain/auth'

const makeCompleteOnboarding =
	(profile: UserProfilePort, session: SessionPort) =>
	async (companyName: string): Promise<void> => {
		await profile.setupOrg(companyName)
		session.patchUser({ onboarded: true })
	}

export { makeCompleteOnboarding }
